export default {
  allContractAggregates: state => {
    return state.contractAggregates || [];
  },
  getCurrentContract: state => {
    return state.currentContract || {};
  },
  getLessors: state => {
    return state.addedLessorsIds || [];
  },
  getUnitOfMeasure: state => {
    return state.unitOfMeasure || [];
  },
  getIsHideCharts: state => {
    return state.isHideCharts;
  },
  getContractState: state => {
    return state.isContractRawEditing;
  },
  contractIsInClosedPeriod: state => {
    return state.isInClosedPeriod;
  },
  getContractStateSimplified: state => {
    return state.isContractSimplifiedEditing;
  },
  getContractConditionsState: state => {
    return state.isContractChangeCondition;
  },
  getContractEventState: state => {
    return state.isContractEventEditing;
  },
  getRenameLessorList: state => {
    return state.renameLessorList;
  }
};
